import { useSiteDetection } from 'shared/hooks';
import { useGetDashboardCharts } from 'api/hooks/dashboard/use-get-dashboard-chart';
import { DateTime } from 'luxon';
import { RenderUnsettledUI, SmallError } from 'shared/components';
import { ShiftOverviewChart } from './shift-overview-chart';

export const ShiftOverviewChartDataProvider = () => {
  const { site } = useSiteDetection();
  const now = DateTime.now();
  const fromDate = now.minus({ months: 3 }).startOf('month').toISODate();
  const toDate = now.plus({ months: 2 }).endOf('month').toISODate();

  const { refetch, status, data, error } = useGetDashboardCharts(site, fromDate, toDate, 'weekly');
  const chartTitle = `${DateTime.fromISO(fromDate).toFormat('dd-MM-yyyy')} naar ${DateTime.fromISO(toDate).toFormat('dd-MM-yyyy')}`;

  if (status === 'error') {
    return (
      <RenderUnsettledUI
        data={{ error, refetch, status }}
        renderError={(error) => <SmallError error={error} />}
      />
    );
  }
  return <ShiftOverviewChart dataset={data} chartTitle={chartTitle} />;
};
